import type { TaxThresholds } from '../../types/tax';

export const TAX_THRESHOLDS_2024_25: TaxThresholds = {
  under65: 95750,    // Under 65: R95,750
  age65to74: 148217, // 65-74: R148,217  
  age75plus: 165689, // 75+: R165,689
};